import React from "react";
/**
 * Tabs controladas (presentacionales).
 *
 * <Tabs value={tab} onChange={setTab}>
 *   <TabList>
 *     <Tab value="general">General</Tab>
 *     ...
 *   </TabList>
 *   <TabPanel when="general">...</TabPanel>
 * </Tabs>
 */
type TabsContextValue = {
    value: unknown;
    onChange: (next: unknown) => void;
};
const TabsContext = React.createContext<TabsContextValue | null>(null);
export default function Tabs({ value, onChange, children, className = "" }: Record<string, any>): any {
    return (<TabsContext.Provider value={{ value, onChange }}>
      <div className={className}>{children}</div>
    </TabsContext.Provider>);
}
export function TabList({ children, className = "" }: Record<string, any>): any {
    return (<div role="tablist" className={`inline-flex items-center gap-1 rounded-lg bg-surface-sunken p-1 ${className}`}>
      {children}
    </div>);
}
export function Tab({ value, children, className = "" }: Record<string, any>): any {
    const ctx = React.useContext(TabsContext);
    const active = ctx?.value === value;
    return (<button type="button" role="tab" aria-selected={active} onClick={(): any => ctx?.onChange?.(value)} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 ${active
            ? "bg-surface text-fg shadow-sm"
            : "text-fg-muted hover:text-fg"} ${className}`}>
      {children}
    </button>);
}
export function TabPanel({ when, children, className = "" }: Record<string, any>): any {
    const ctx = React.useContext(TabsContext);
    if (ctx?.value !== when)
        return null;
    return (<div role="tabpanel" className={className}>
      {children}
    </div>);
}
